import type { AgentOptions } from "@newrelic/browser-agent/loaders/agent";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

if (import.meta.env.VITE_NEWRELIC_ENABLED === "true") {
  const options: AgentOptions = {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ["bam.nr-data.net"] },
    },
    info: {
      beacon: "bam.nr-data.net",
      errorBeacon: "bam.nr-data.net",
      licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY || "",
      applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID || "",
      sa: 1,
    },
    loader_config: {
      accountID: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID,
      trustKey: import.meta.env.VITE_NEWRELIC_TRUST_KEY,
      agentID: import.meta.env.VITE_NEWRELIC_AGENT_ID,
      licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY,
      applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID,
    },
    loaderType: "browser-agent",
  };

  const agent = new BrowserAgent(options);
  agent.start();
}
